<script>
export default {
  test1: 'Log',
  curUser: {
    userName: '',
    openId: '',
    keyInfo: '',
    deptId: 1007702,
    schoolYear: 0
  },
  deptId: 1007702,
  loginType: '01', // 01 从本系统登录 02 从外部系统登录
  userRealDept: {},
  userName: '', // 当前登录用户
  curStudent: {},
  userRightDeptList: [
    {deptId: 1007702, deptNo: '107702', deptName: '西安翻译学院', parentDeptId: 0, shortName: '西安翻译学院', deptLevel: 1, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '', sumLevel: ''}
  ],
  payUrl: '',
  staticResourceAddr: 'http://static.xafy.edu.cn/images/',
  staticUploadAddr: 'http://static.xafy.edu.cn',
  appTitle: '缴费平台', // 标题 -- 宅付通；海棠通

  tableHeight: 380,
  editInline: false,
  commonParam: {
    curSystem: '01', // 01 通用 02 宅付通
    homePage: './components/Pay/MyBill',
    bannerLogo: './assets/theme-default/images/zftlogo'
  },
  // 分页对象
  page: {
    size: 50,
    totalElements: 0,
    totalPages: 0,
    pageSizes: [15, 50, 100, 500],
    number: 0
  },
  theme: 'theme-default',
  // 用户个性化
  userCustom: {
    isTab: false
  },
  uiSetItemList: [],
  uiSetList: [],
  modeList: [],
  typeIdList: 'Access_URL_Payment,Platform_NO,Extras_Project,CM_OldStuPayTime,Term_XF,CM_NewStuPayTime,CM_OldStuImpPayTime,XF_Coat_Size,XF_Shirt_Size,XF_Shoes_Size,CM_OtherPayTime,XF_Bank_Type,CM_ZSBStuPayTime,Dorm_Supply_Config,Dorm_Supply_Config_Old,Phone_Number_Code_XF,App_Param,Loan_Max_Set,Apart_Supply_Kind,CM_Block_Receive_Time,,A套餐',
  uiSetIdList: 'tbIf_Order_Info_Common,tbIf_Order_Info_XiFan,tbIf_Order_Info_XiFan_New,tbIf_Order_Info_XiFan_Exam',
  pageMap: [
    {type: '00', tabName: 'default', pageName: 'LoginXiFan', title: '西安翻译学院', pageUrl: 'XiFan/LoginXiFan'},
    {type: '01', tabName: 'default', pageName: 'DormOldLogin', title: '宿舍登录', pageUrl: 'XiFan/LoginDormOld'}
  ],
  type: '00',
  isLoan: '0',
  phoneModeList: [],
  insuranceSet: 0,
  dormConfigSet: 0
}
</script>



// WEBPACK FOOTER //
// Global.vue?395aca9c